
export enum FeeType {
  FIXED = 'FIXED',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export enum BillingCadence {
  MONTHLY = 'Månadsvis',
  QUARTERLY = 'Kvartalsvis',
  YEARLY = 'Årsvis'
}

export interface QuoteItem {
  id: string;
  name: string;
  description: string;
  price: number;
  quantity: number;
  type: FeeType;
}

export interface ClientInfo {
  companyName: string;
  contactPerson: string;
  email: string;
  address: string;
}

export interface SenderInfo {
  name: string;
  phone: string;
  email: string;
}

export interface QuoteData {
  id: string;
  date: string;
  validUntil: string;
  client: ClientInfo;
  sender: SenderInfo;
  items: QuoteItem[];
  billingCadence: BillingCadence;
  notes: string;
  momsRate: number; // usually 0.25 for Sweden
}
